import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";

export default {
    title: "Components/Product Highlight Slider",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    component: "ux-iws-product-highlight-slider",
    args: {
        noHighlight: false,
    },
    argTypes: {
        noHighlight: {
            control: "boolean",
        },
    },
};

const ProductHighlightSliderTemplate = ({ noHighlight }) => html`
    <ux-iws-product-highlight-slider ?no-highlight="${noHighlight}">
        ${[1, 2, 3, 4, 5, 6, 7, 8, 9].map(
            (i) => html`
                <ux-slider-slide>
                    <ux-iws-teaser-product-tile
                        product-image-url="mock-assets/images/TruLaser-highlight.png"
                        product-name="TruLaser${i === 1
                            ? " HIGHLIGHT"
                            : ""} 7000"
                        product-desc="Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua."
                        eyecatcher="${i === 1 ? ".NEW" : ""}"
                    >
                        <a
                            href="#"
                            class="ux-text-link ux-iws-teaser-product-tile__link"
                        >
                            Zum Produkt
                            <ux-icon name="arrow-small-right"></ux-icon>
                        </a>
                    </ux-iws-teaser-product-tile>
                </ux-slider-slide>
            `
        )}
    </ux-iws-product-highlight-slider>
`;

export const Default = ProductHighlightSliderTemplate.bind({});
Default.args = {
    noHighlight: false,
};
